import { render } from "./PrivacyStatement.vue?vue&type=template&id=bd992364&scoped=true"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js"

import "./PrivacyStatement.vue?vue&type=style&index=0&id=bd992364&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd992364"]])

export default __exports__